// sectionTypeContext.tsx
import type React from 'react';
import { createContext, useContext, useMemo } from 'react';

export type SectionType = 'FRONTOFFICE' | 'BACKOFFICE' | 'DOCUMENT' | 'NONE';

interface SectionTypeContextType {
  sectionType: SectionType;
}

const SectionTypeContext = createContext<SectionTypeContextType | undefined>(
  undefined,
);

interface IProps {
  children: React.ReactNode;
  sectionType: SectionType;
}

export function SectionTypeProvider(props: IProps) {
  const value = useMemo(() => {
    return { sectionType: props.sectionType };
  }, [props.sectionType]);

  return (
    <SectionTypeContext.Provider value={value}>
      {props.children}
    </SectionTypeContext.Provider>
  );
}

/**
 * Hook che permette di sapere dal context se ci si trova all'interno della
 * configurazione di una sezione (frontoffice) o di una sezione dati (backoffice).
 *
 * Utilizzato in admin.
 */
const DEFAULT_CONTEXT: SectionTypeContextType = { sectionType: 'NONE' };

export const useSectionType = (): SectionTypeContextType => {
  const context = useContext(SectionTypeContext);
  return context ?? DEFAULT_CONTEXT;
};
